import { createContext } from 'react';
import { ComponentDescriptor } from '../..';
type State = { [key: string]: unknown };
export interface IPageContext {
  name?: string;
  components?: ComponentDescriptor[];
  state?: State;
  setState?: (state: State) => any;
}
export const PageContext = createContext<IPageContext>({});

export default PageContext;
